import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import { useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { FcViewDetails } from "react-icons/fc";
import StepRoutes from "../../../Routes/steps_routes";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const CampaignStatView = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();

  useEffect(() => {
    setLoading(true);
    performRequest(
      "GET",
      `/cherrioSystem/getWhatsAppCampaignAnalyticsSummery/${id}`
    )
      .then((res) => {
        if (res.status === 200) {
          setData(res?.data?.detailCampaignObj);
        } else {
          Toast("error", "Error while getting Specification!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const funnelData = [
    {
      name: "Total",
      value: data?.campaignSize || 0,
      percentage: "100%",
    },
    {
      name: "Sent",
      value: data?.campaignSent || 0,
      percentage: `${data?.campaignSentPercentage}%`,
    },
    {
      name: "Delivered",
      value: data?.campaignDelivered || 0,
      percentage: `${data?.campaignDeliveredPercentage}%`,
    },
    {
      name: "Opened",
      value: data?.campaignOpened || 0,
      percentage: `${data?.campaignopenedPercentage}%`,
    },
  ];

  if (loading || !data) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row align-items-center">
              <div className="col-md-8">
                <h2 className="page-title mb-1">
                  <FcViewDetails className="fs-2 me-1" />
                  Detail Campaign Stat
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12 col-sm-12 py-2">
              <div className="card">
                <div className="h-100">
                  <div className="card-header">
                    <h3 className="card-title">
                      Campaign Name {data?.campaignName}
                    </h3>
                  </div>
                  <div className="card-body p-0">
                    <div className="p-4">
                      <div className="row text-center mb-4">
                        {funnelData.map((item, index) => (
                          <div className="col" key={index}>
                            <h3 className="text-muted">{item.name}</h3>
                            <h4 className="fw-bold">{item.value}</h4>
                            <small>{item.percentage}</small>
                          </div>
                        ))}
                      </div>
                      <hr />

                      <div
                        style={{
                          width: "100%",
                          height: "250px",
                          display: "flex",
                          alignItems: "center",
                          overflow: "hidden",
                        }}
                      >
                        {funnelData.map((item, index) => {
                          const widthPercentage =
                            (item.value / data.campaignSize) * 100;

                          return (
                            <div
                              key={index}
                              style={{
                                width: `${widthPercentage}%`,
                                height: `${220 - index * 40}px`,
                                background:
                                  index === 0
                                    ? "#0d6efd"
                                    : index === 1
                                    ? "#198754"
                                    : index === 2
                                    ? "#20c997"
                                    : "#0dcaf0",
                                clipPath:
                                  index === funnelData.length - 1
                                    ? "polygon(0 0, 100% 50%, 0 100%)"
                                    : "none",
                                marginRight: "2px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "white",
                                fontWeight: "bold",
                              }}
                            >
                              {item.name}
                            </div>
                          );
                        })}
                      </div>
                      <hr />
                    </div>

                    <table className="table table-striped table-sm mb-0">
                      <tbody>
                        <tr>
                          <td>Campaign Date & Time</td>
                          <td className="fw-bold ">
                            {data.campaignDateAndTime}
                          </td>
                        </tr>

                        <tr>
                          <td>Campaign Size</td>
                          <td className="fw-bold ">{data.campaignSize}</td>
                        </tr>

                        <tr>
                          <td>Campaign Sent</td>
                          <td className="fw-bold ">
                            {data.campaignSent} ({data.campaignSentPercentage}%)
                          </td>
                        </tr>

                        <tr>
                          <td>Campaign Delivered</td>
                          <td className="fw-bold ">
                            {data.campaignDelivered} (
                            {data.campaignDeliveredPercentage}%)
                          </td>
                        </tr>

                        <tr>
                          <td>Campaign Open</td>
                          <td className="fw-bold ">
                            {data.campaignOpened} (
                            {data.campaignopenedPercentage}%)
                          </td>
                        </tr>

                        <tr>
                          <td>Campaign Template Component </td>
                          <td className="fw-bold ">
                            {data?.templateComponentData?.map((item, index) => (
                              <div key={index} style={{ marginBottom: "10px" }}>
                                <strong>{item.type}</strong>

                                {item.text && (
                                  <div style={{ whiteSpace: "pre-line" }}>
                                    {item.text}
                                  </div>
                                )}

                                {item.buttons &&
                                  item.buttons.map((btn, i) => (
                                    <div key={i}>
                                      {btn.text} ({btn.type}) -{" "}
                                      {btn.phone_number}
                                    </div>
                                  ))}
                              </div>
                            ))}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default CampaignStatView;
